import { DataGrid } from '@cimplico/components';
import { Link, useSearchParams } from 'react-router-dom';
import { JournalOverview, JournalStatusEnum } from '../../types/journal';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useFirmContext } from '../../providers/FirmProvider';
import { WorkpaperRoleEnum } from '../../types/workpaper';
import Currency from '../../components/currency/Currency';
import JournalStatusBadge from '../../components/journal-status-badge/JournalStatusBadge';
import JournalDetails from '../journal-overview/JournalDetails';

type JournalRowProps = {
    id: string;
    journal: JournalOverview;
    onClick?: (journalId: string) => void;
};

function JournalRow({ id, journal, onClick }: JournalRowProps): JSX.Element {
    const [params] = useSearchParams();
    const { shortId } = useFirmContext();
    const { id: workpaperId, role } = useWorkpaperContext();

    const roleCanPost = role === WorkpaperRoleEnum.REVIEWER || role === WorkpaperRoleEnum.APPROVER;

    return (
        <DataGrid.Row id={id} disabled={journal.status !== JournalStatusEnum.DRAFT && !roleCanPost}>
            <div className="flex flex-col items-start gap-1">
                <div className="flex items-center gap-2">
                    {onClick ? (
                        <p
                            className="font-medium text-indigo-600 dark:text-indigo-400 text-sm cursor-pointer"
                            onClick={(): void => onClick(journal.id)}
                        >
                            JNL#{journal.reference.toString().padStart(3, '0')}
                            {journal.narration ? ` - ${journal.narration}` : ''}
                        </p>
                    ) : (
                        <Link to={`/${shortId}/workpapers/${workpaperId}/journals/${journal.id}${params && `?${params}`}`}>
                            <p className="font-medium text-indigo-600 dark:text-indigo-400 text-sm cursor-pointer">
                                JNL#{journal.reference.toString().padStart(3, '0')}
                                {journal.narration ? ` - ${journal.narration}` : ''}
                            </p>
                        </Link>
                    )}
                </div>
                <JournalDetails journal={journal} />
            </div>
            <Currency value={journal.debitTotal} description="Dr" className="text-xs text-gray-700 dark:text-white/[0.87]" />
            <Currency value={journal.creditTotal} description="Cr" className="text-xs text-gray-700 dark:text-white/[0.87]" />
            <JournalStatusBadge status={journal.status} />
        </DataGrid.Row>
    );
}

export default JournalRow;
